export default function ContactInfoSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left - Meeting Room Image */}
          <div className="lg:col-span-5">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20photography%20of%20a%20high-end%20Japanese%20corporate%20meeting%20room%20with%20a%20large%20wooden%20table%2C%20comfortable%20chairs%2C%20glass%20wall%20with%20cityscape%20view%2C%20warm%20modern%20lighting%2C%20minimalist%20design%2C%20empty%20room%2C%20no%20people%2C%20premium%20corporate%20hospitality&width=800&height=600&seq=contact-meeting-room&orientation=landscape"
                alt="会議室"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right - Contact Info */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <div className="space-y-10">
              {/* Phone */}
              <div>
                <a
                  href="tel:0352158420"
                  className="text-5xl md:text-7xl font-heading font-light text-foreground-950 tracking-tight hover:text-primary-700 transition-colors duration-300 cursor-pointer"
                >
                  03-5215-8420
                </a>
                <div className="mt-4 space-y-1 text-sm text-foreground-500 tracking-[0.06em] font-sans font-light">
                  <p>営業時間：平日 9:00 - 18:00</p>
                  <p>メール：
                    <a href="mailto:admin@bankcard-chcak.jp" className="text-foreground-700 hover:text-accent-600 transition-colors cursor-pointer">
                      admin@bankcard-chcak.jp
                    </a>
                  </p>
                </div>
              </div>

              <a
                href="tel:0352158420"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm tracking-[0.08em] font-sans font-light hover:bg-foreground-50 hover:border-foreground-400 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                今すぐ電話する
                <i className="ri-phone-line text-base" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}